// Per-model configuration for the forecast-comparison charts. Solution IDs are
// no longer hardcoded — each (fct, model) is resolved dynamically through the
// solutions/forecast list (filtered by fct + model_name + model_version), then
// the run + model-outputs are fetched. See useFctForecasts.
import { graphConfig } from '@/configs/Graphs';

// Shared series colors so the standalone model charts and the comparison chart
// agree on how each model renders: BFG teal, Incumbent (ETS) red.
export const BFG_COLOR = graphConfig.colors.forecast;
export const INCUMBENT_COLOR = '#dc2626';

export type FctModelConfig = {
  // Display name used in the chart legend ("BFG v2.2", "Incumbent").
  label: string;
  // solutions/forecast filter values.
  modelName: string;
  modelVersion: string;
  grainDays: number;
};

// Convert the source-of-truth (daily-grain) LTSP into the model's own grain.
export function toModelLeadtimeSpans(config: FctModelConfig, ltsp: Array<[number, number]>): Array<[number, number]> {
  return ltsp.map(([leadTime, span]) => [leadTime / config.grainDays, span / config.grainDays]);
}

// Default LTSP seeded from the home page (BFG v2.2's weekly point).
export const BFG_DEFAULT_LEADTIME_SPAN: [number, number] = [0, 7];

// TODO(engineer): hardcoded FCT date list, seeded once from the home page rather than
// fetched. Follow-up: source available FCTs from the solutions/forecast list endpoint
// (same source useFctForecasts already uses to resolve solution ids) so new forecast
// cycles show up without a code change.
// Default FCTs seeded from the home page (shared across BFG / ETS runs).
export const DEFAULT_FCTS: string[] = [
  '2025-05-04',
  '2025-04-27',
  '2025-04-20',
  '2025-04-13',
  '2025-04-06',
  '2025-03-30',
  '2025-03-23',
  '2025-03-16',
  '2025-03-09',
  '2025-03-02',
  '2025-02-23',
  '2025-02-16',
  '2025-02-09',
  '2025-02-02',
];

// TODO(engineer): modelName/modelVersion/label are hardcoded per model rather than
// tenant-configurable, so onboarding a new model or bumping a version requires a code
// change. Follow-up: move model identity/version/label into per-tenant control-plane
// config once the control plane exposes a model registry (see docs/CLAUDE.md §2.7).
export const BFG_MODEL_CONFIG: FctModelConfig = {
  label: 'BFG v2.2',
  modelName: 'bfg',
  modelVersion: '2.2',
  grainDays: 1, // daily grain — the LTSP is authored in these units, so no conversion.
};

export const INCUMBENT_MODEL_CONFIG: FctModelConfig = {
  label: 'Incumbent',
  modelName: 'ets',
  modelVersion: '1.0',
  grainDays: 7, // weekly grain — [7, 7] daily LTSP → [1, 1] weekly request.
};
